module.exports = __webpack_public_path__ + "static/sorrowful_3-1d32b4d2167b2a7608146abdadf7a83e.jpg";